import * as React from 'react';

import { Card } from '@blueprintjs/core';

import CardContainer from '../common/CardContainer';
import AdminNavBar from './AdminNavBar';

import Sections from '../../components/admin/sections';
import AdminEditOfficePage from '../../components/admin/sections/AdminEditOfficePage';
import AdminCreateOfficePage from '../../components/admin/sections/AdminCreateOfficePage';
// import ConfigPage from './sections/ConfigPage';

import { Switch, RouteComponentProps } from 'react-router-dom';
import RoutePrivate from '../router/RoutePrivate';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import UserDetails from 'src/models/UserDetails';

interface IAdminPageStateProps {
    isLoggedIn: boolean;
    user: UserDetails;
}

export interface IAdminPageDispatchProps {
    navigate: (path: string) => void;
}

type IAdminPageProps = RouteComponentProps<{}> & IAdminPageStateProps & IAdminPageDispatchProps;

class AdminPage extends React.Component<IAdminPageProps> {
    public render() {
        return (
            <CardContainer>
                <Card elevation={1}>
                    <div className="card-header">Admin</div>
                    <AdminNavBar
                        matchUrl={this.props.match.url}
                        location={this.props.location.pathname}
                        user={this.props.user}
                        navigate={this.props.navigate}
                    />
                    <Switch>
                        <RoutePrivate
                            key="admin-user"
                            path={this.props.match.path + '/users'}
                            component={Sections.Users}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="admin-client"
                            path={this.props.match.path + '/clients'}
                            component={Sections.Clients}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="admin-create-user"
                            path={this.props.match.path + '/create-user'}
                            component={Sections.CreateUser}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="admin-edit-user"
                            path={this.props.match.path + '/edit-user/:userId'}
                            component={Sections.CreateUser}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="list-office"
                            path={this.props.match.path + '/offices'}
                            component={Sections.Offices}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="edit-office"
                            path={this.props.match.path + '/edit-office/:id'}
                            component={AdminEditOfficePage}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="create-office"
                            path={this.props.match.path + '/create-office'}
                            component={AdminCreateOfficePage}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        {/* <RoutePrivate
                            key="config"
                            path={this.props.match.path + '/config'}
                            component={ConfigPage}
                            isLoggedIn={this.props.isLoggedIn}
                        /> */}
                    </Switch>
                </Card>
            </CardContainer>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoggedIn: selectors.auth.isLoggedIn(state),
    user: selectors.auth.user(state),
});

const mapDispatchToProps: IAdminPageDispatchProps = {
    navigate: (path: string) => push(path),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);



// WEBPACK FOOTER //
// ./src/components/admin/AdminPage.tsx